// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1UXTE","header":"PatientBlock_header__1oALW","label":"PatientBlock_label__3ooUs","option":"PatientBlock_option__2FFUe"};